<section class="relative h-[calc(100svh-50px)] pb-12">
  @let gradientClass = "bg-[linear-gradient(180deg,rgba(0,0,0,0)_70.18%,rgba(0,0,0,0.6)_90.38%)] bg-cover bg-no-repeat";
  @if (data.image; as image) {
    <div class="mask-curve-bottom z-0 h-[calc(100svh-100px)]">
      <app-image [image]="image" [isPriority]="!isImageInPreviousBlocks" [pregenerationSize]="{ width: 1920 }" />
      <div [class]="gradientClass" class="pointer-events-none absolute inset-0"></div>
    </div>
  }
  <div class="absolute inset-0 flex flex-col items-center justify-end gap-y-5 px-5 pb-[30px]">
    @if (data.title; as title) {
      <app-title [title]="title" class="text-center text-white" size="h1" />
    }
    @if (data.cta; as cta) {
      @let gtm = data.gtmConfigCta;
      <app-button
        (onButtonClick)="
          emitGtmEvent({
            event: gtm?.event,
            group: gtm?.group,
            description: gtm?.description,
            context: gtm?.context,
            button_text_value: cta.label,
            event_type: 'click',
          })
        "
        [label]="cta.label"
        [url]="cta.url" />
    }
  </div>
</section>
